import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import router from '@/router';
import { icons } from '@/plugins/mdi.ts'


@Module({ name: 'app', namespaced: true, dynamic: true, store: store })
class AppStore extends VuexModule {
  /* For MaterialDesign */
  drawer: boolean = true;
  color: string = 'success';
  image: string = 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg';

  @Mutation SET_DRAWER( val: boolean ) { this.drawer = val; }
  @Mutation SET_COLOR( val: string ) { this.color = val; }
  @Mutation SET_IMAGE( val: string ) { this.image = val; }

  /* metaInfo */
  title: string = "";
  backLink: string = "";

  @Mutation SET_TITLE( val: string ) { this.title = val; }
  @Mutation SET_BACK_LINK( val: string ) { this.backLink = val; }

  /* state */
  errorMessage: string = "";
  @Mutation SET_ERROR_MESSAGE( val: string ) { this.errorMessage = val; }

  /* for Snackbar */
  snackVisible: boolean = false;
  snackMessage: string = "";
  snackColor: string = "success";
  snackIcon: string = "";

  @Mutation TOGGLE_DRAWER() { this.drawer = !this.drawer; }
  @Mutation SHOW_SNACK() { this.snackVisible = true; }
  @Mutation HIDE_SNACK() { this.snackVisible = false; }
  @Mutation SET_SNACK_MESSAGE( val: string ) { this.snackMessage = val; }
  @Mutation SET_SNACK_COLOR( val: string ) { this.snackColor = val; }
  @Mutation SET_SNACK_ICON( val: string ) { this.snackIcon = val; }


  /* for Dialog */
  dialogVisible: boolean = false;
  dialogMessage: string = "";
  dialogCaption: string = "";
  dialogPromiseResolver?: (value: boolean) => void;
  dialogMode: string = "yesno";

  /* for Search */
  searchText: string = "";
  
  @Mutation UPDATE_SEARCH_TEXT(val: string) { this.searchText = val; }

  @Mutation SHOW_DIALOG() { this.dialogVisible = true; }
  @Mutation HIDE_DIALOG() {
    this.dialogVisible = false;
    if(this.dialogPromiseResolver)
      this.RESOLVE_DIALOG_PROMISE(false);
  }
  @Mutation SET_DIALOG_MESSAGE( val: string ) { this.dialogMessage = val; }
  @Mutation SET_DIALOG_CAPTION( val: string ) { this.dialogCaption = val; }
  @Mutation SET_DIALOG_MODE( val: string ) { this.dialogMode = val; }
  @Mutation SET_DIALOG_PROMISE_RESOLVER(resolver: (value: boolean) => void) {
    this.dialogPromiseResolver = resolver;
  }
  @Mutation RESOLVE_DIALOG_PROMISE( val: boolean ) {
    if(this.dialogPromiseResolver) {
      this.dialogPromiseResolver(val);
      this.dialogPromiseResolver = undefined;
    }
  }


  /* Actions */
  @Action({ rawError: true })
  showErrorPage( val: string ) {
      this.SET_ERROR_MESSAGE(val);
      router.push({ name: 'error' });
  }

  @Action({ rawError: true })
  showError( val: string ) {
    console.log("showError");
    this.SET_SNACK_ICON(icons.alertCircle);
    this.SET_SNACK_COLOR('error');
    this.SET_SNACK_MESSAGE(val);
    this.SHOW_SNACK();
  }

  @Action({ rawError: true })
  showSuccess( val: string ) {
    this.SET_SNACK_ICON(icons.checkCircle);
    this.SET_SNACK_COLOR('success');
    this.SET_SNACK_MESSAGE(val);
    this.SHOW_SNACK();
  }

  @Action({ rawError: true })
  showConfirm({ message, caption } : { message: string, caption?: string }) {
    const dialogPromise = new Promise<boolean>((resolve, reject) => {
      this.SET_DIALOG_PROMISE_RESOLVER(resolve);
    })
    this.SET_DIALOG_MESSAGE(message);
    this.SET_DIALOG_MODE('yesno');
    if(caption)
      this.SET_DIALOG_CAPTION(caption);
    this.SHOW_DIALOG();
    return dialogPromise;
  }

  @Action({ rawError: true })
  showAlert({ message, caption }: { message: string, caption?: string }) {
    const dialogPromise = new Promise<boolean>((resolve, reject) => {
      this.SET_DIALOG_PROMISE_RESOLVER(resolve);
    })
    this.SET_DIALOG_MESSAGE(message);
    this.SET_DIALOG_MODE('ok');
    if(caption)
      this.SET_DIALOG_CAPTION(caption);
    this.SHOW_DIALOG();
    return dialogPromise;
  }
}

export default getModule(AppStore);
